module.exports = __webpack_public_path__ + "static/img/icon_next@2x.91e6a1f6.png";